import NoSsr from '@common/noSsr';
import BottomNudge from '@common/nudges/bottomNudge';
import TopNudge from '@common/nudges/topNudge';
import { fetchNudges } from '@repository/nudges/useNudges';
import { BottomNudgeVO, TopNudgeVO } from '@domain/vo/NudgeVO';
import { BottomNudgeRs, TopNudgeRs } from '@domain/rs/NudgeRs';
import { NUDGE_RS_TYPE } from '@domain/constant/nudgeType';
import useOnMount from '@utils/hooks/useOnMount';

type FilteredNudgeRs = TopNudgeRs | BottomNudgeRs;

const topNudges = new Map<string, TopNudgeVO>();
const bottomNudges = new Map<string, BottomNudgeVO>();

interface NudgeWrapperProps {
  children: React.ReactNode;
}

// 공통 상단, 하단 넛지 출력용 공통 Wrapper
const NudgeWrapper = ({ children }: NudgeWrapperProps) => {
  useOnMount(() => {
    const updateNudges = async () => {
      const nudges = await fetchNudges();
      const filteredNudges = nudges.nudgeInfoList.filter((rs) => rs.type !== 'MOBILE_BOTTOM') as FilteredNudgeRs[];
      filteredNudges.forEach((nudge) => {
        switch (nudge.type) {
          case NUDGE_RS_TYPE.TOP_BANNER:
            if (!nudge.hasPath) {
              topNudges.set('global', new TopNudgeVO(nudge));
              return;
            }
            nudge.pathList.forEach((path) => {
              topNudges.set(path, new TopNudgeVO(nudge));
            });
            break;
          case NUDGE_RS_TYPE.BOTTOM_BANNER:
            if (!nudge.hasPath) {
              bottomNudges.set('global', new BottomNudgeVO(nudge));
              return;
            }
            nudge.pathList.forEach((path) => {
              bottomNudges.set(path, new BottomNudgeVO(nudge));
            });
            break;
        }
      });
    };

    updateNudges();
  });

  return (
    <>
      <NoSsr>
        <TopNudge topNudges={topNudges} />
      </NoSsr>
      {children}
      <BottomNudge bottomNudges={bottomNudges} />
    </>
  );
};

export default NudgeWrapper;
